export enum EColumnType {
  ACTION = 'ACTION',
  NUMBER = 'NUMBER',
  STRING = 'STRING',
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  CURRENCY = 'CURRENCY',
  ENUM = 'ENUM',
  CPF_CNPJ = 'CPF_CNPJ',
  MODAL = 'MODAL',
  CHECKBOX = 'CHECKBOX',
  PHONE = 'PHONE'
}
